import React from 'react';
import Swal from 'sweetalert2';
import { common, popupContent, translations } from '../../lib';
import './data-processing.css';

const DataProcessingModal = (): any => {
    Swal.fire({
        html: popupContent,
        showClass: {
            backdrop: 'swal2-noanimation',
            popup: '',
        },
        hideClass: {
            popup: '',
        },
        width: 700,
        confirmButtonColor: '#c21b17',
        confirmButtonText: common.NEXT,
        allowOutsideClick: false,
        allowEscapeKey: false,
        input: 'checkbox',
        inputPlaceholder: translations.intro.ACCEPT_DATA_PROCESSING,
        inputValidator: (value) => {
            return new Promise((resolve) => {
                if (value == '1') {
                    resolve('');
                } else {
                    resolve(translations.intro.ACCEPT_DATA_PROCESSING_NOTIFICATION);
                }
            });
        },
    });
};

export default DataProcessingModal;
